import type {
  CreateOnsiteInjectionDto,
  OnsiteInjectionDto,
} from "@intelligems/ig-types/dtos/onsite-injections";
import type { OnsiteEditDto } from "@intelligems/ig-types/dtos/onsite-edits";

interface Stats {
  count: number;
  types: Set<string>;
}

export function getModStats(
  onsiteEdits: OnsiteEditDto[],
  onsiteInjections: (CreateOnsiteInjectionDto | OnsiteInjectionDto)[],
  source: string
) {
  const stats = getAllModStats(onsiteEdits, onsiteInjections);
  const sourceStats = stats[source];
  if (sourceStats) {
    return { count: sourceStats.count, types: Array.from(sourceStats.types) };
  } else {
    return { count: 0, types: [] };
  }
}

export function getAllModStats(
  onsiteEdits: OnsiteEditDto[],
  onsiteInjections: (CreateOnsiteInjectionDto | OnsiteInjectionDto)[]
) {
  const result: { [key: string]: Stats } = {
    overall: { count: 0, types: new Set() },
  };

  const register = (source: string | null | undefined, type: string) => {
    source ||= "unspecified";
    const sourceStat =
      result[source] ?? (result[source] = { count: 0, types: new Set() });
    sourceStat.types.add(type);
    sourceStat.count++;
    result.overall.types.add(type);
    result.overall.count++;
  };

  for (const edit of onsiteEdits ?? []) {
    const type = getOnsiteEditType(edit);
    register(edit.source, type);
  }
  for (const injection of onsiteInjections ?? []) {
    const type = getOnsiteInjectionType(injection);
    register(injection.source, type);
  }

  return result;
}

function getOnsiteEditType(edit: OnsiteEditDto) {
  if (edit.onsiteEditType === "text") {
    return "text";
  }
  if (edit.onsiteEditType === "image") {
    return "image";
  }
  const html = edit.replace.trim();
  if (html.startsWith("<ig-generic-component>")) {
    return "generic_component";
  }
  if (html.startsWith("<ig-text-component>")) {
    return "text_component";
  }
  if (html.startsWith("<ig-image-component>")) {
    return "image_component";
  }
  if (html.startsWith("<ig-banner-component>")) {
    return "banner_component";
  }
  return "html";
}

function getOnsiteInjectionType(
  _injection: CreateOnsiteInjectionDto | OnsiteInjectionDto
) {
  return "css_js";
}
